import React from 'react'
import { useParams } from 'react-router-dom'
import { withProtectedRoute, roles, useAuth } from 'lib/auth'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Undo from 'components/material-symbol/icons/Undo'
import { PageHeader } from 'components/page-header'
import AccountTransactionSummary from './account-transaction-summary'
import RefundDialog from './refund-dialog'
import useGetRegistrationPayment from 'components/transaction-summary/use-get-registration-payment'
import LinearProgress from '@material-ui/core/LinearProgress'
import SensitiveInfoWrapper from 'lib/auth/SensitiveInfoWrapper'
import Error from 'components/error'
import { useStyles } from './styles'
import { canShowOnlineRefund } from '../transaction-helpers'

const TRANSACTIONS_PATH = '/account/payments/transactions'

const transactionListCrumb = [{ label: 'Transactions', to: TRANSACTIONS_PATH }]

const TransactionDetailPage = () => {
  const classes = useStyles()
  const { isCoach } = useAuth()
  const { transactionId } = useParams()
  const { data, loading, error, refetch } = useGetRegistrationPayment(
    transactionId,
  )

  if (loading) return <LinearProgress />
  if (error) return <Error error={error} />

  const { paymentSourceType, registrationPayment } = data
  const { products, transactions, cardBrand, last4 } = registrationPayment
  const leftToRefund = registrationPayment.leftToRefundInCents / 100.0
  const canRefund = canShowOnlineRefund({
    transactions,
    cardBrand,
    last4,
    leftToRefundInCents: registrationPayment.leftToRefundInCents,
    productTypeName: products[0].__typename,
    isCoach,
  })

  return (
    <>
      <PageHeader
        title={`Transaction #${transactionId}`}
        crumbs={transactionListCrumb}
      />
      <SensitiveInfoWrapper enableFallback>
        <Box className={classes.contentContainer}>
          <Box className={classes.stack}>
            <AccountTransactionSummary
              paymentSourceType={paymentSourceType}
              registrationPayment={registrationPayment}
            />
            {canRefund ? (
              <Box className={classes.refundCard}>
                <Box className={classes.refundCopy}>
                  <Typography className={classes.refundTitle}>
                    Need to reverse this transaction?
                  </Typography>
                  <Typography className={classes.refundCaption}>
                    Process a refund for the consumer or adjust the coaching
                    fee.
                  </Typography>
                </Box>
                <RefundDialog
                  trigger={
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.refundButton}
                      startIcon={<Undo className={classes.refundButtonIcon} />}
                    >
                      Add Refund
                    </Button>
                  }
                  registrationPaymentId={registrationPayment.id}
                  leftToRefund={leftToRefund}
                  onSuccess={refetch}
                />
              </Box>
            ) : null}
          </Box>
        </Box>
      </SensitiveInfoWrapper>
    </>
  )
}

export default withProtectedRoute(TransactionDetailPage, [
  roles.COACH,
  roles.CONSUMER,
])
